import { Controller } from "@hotwired/stimulus"

// File drop controller - drag & drop ondersteuning voor een file input,
// inclusief weergave van de gekozen bestandsnaam.
export default class extends Controller {
  static targets = ["input", "fileName", "zone"]
  static classes = ["dragging"]

  connect() {
    this.defaultLabel = this.hasFileNameTarget ? this.fileNameTarget.textContent : ""
  }

  // Toont de geselecteerde bestandsnaam (zowel na klikken als na slepen).
  display() {
    if (!this.hasFileNameTarget) return
    const file = this.inputTarget.files[0]
    this.fileNameTarget.textContent = file ? file.name : this.defaultLabel
  }

  dragover(event) {
    event.preventDefault()
    this.highlight(true)
  }

  dragleave(event) {
    event.preventDefault()
    this.highlight(false)
  }

  drop(event) {
    event.preventDefault()
    this.highlight(false)

    const files = event.dataTransfer?.files
    if (!files || files.length === 0) return

    // DataTransfer gebruiken zodat de file input de gesleepte file overneemt.
    const data = new DataTransfer()
    data.items.add(files[0])
    this.inputTarget.files = data.files
    this.display()
  }

  highlight(on) {
    if (!this.hasZoneTarget) return
    this.draggingClasses.forEach((cls) => this.zoneTarget.classList.toggle(cls, on))
  }
}
